// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type PlayArrow24CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const PlayArrow24CircleFilled: FC<PlayArrow24CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm7-16L12 9v14l11-7Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default PlayArrow24CircleFilled;
